"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductTile = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _tsUtils = require("@ori/ts-utils");
var _react = require("react");
var _common = require("../../common");
var _ImageBox = require("./ImageBox");
var _Price = require("./Price");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ProductTile = ({
  brandName,
  buttons,
  className,
  currentPrice,
  description,
  labels,
  mrpText,
  name,
  oldPrice,
  productCode,
  productImageUrls,
  relativeUrl,
  testId
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    primaryButton,
    secondaryButton
  } = buttons ?? {};
  const content = (0, _react.useMemo)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageBox.ImageBox, {
      buttons: buttons,
      labels: labels,
      productCode: productCode,
      productImageUrls: productImageUrls
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Info, {
      children: [brandName ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Brand, {
        children: [brandName, /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowRightThin, {})]
      }) : null, name ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Name, {
        variant: "h6",
        component: "h6",
        children: name
      }) : null, description ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Description, {
        children: description
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Price.Price, {
        currentPrice: currentPrice,
        mrpText: mrpText,
        oldPrice: oldPrice
      }), (0, _tsUtils.isNonNullable)(primaryButton) || (0, _tsUtils.isNonNullable)(secondaryButton) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Buttons, {
        children: [primaryButton ?? null, secondaryButton ?? null]
      }) : null]
    })]
  }), [brandName, buttons, currentPrice, description, labels, mrpText, name, oldPrice, primaryButton, productCode, productImageUrls, secondaryButton]);
  if (relativeUrl) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.RootLink, {
      className: className,
      "data-testid": testId ?? getTestId(_common.PRODUCT_TILE),
      href: relativeUrl,
      children: content
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    className: className,
    "data-testid": testId ?? getTestId(_common.PRODUCT_TILE),
    children: content
  });
};
exports.ProductTile = ProductTile;
//# sourceMappingURL=ProductTile.js.map